// import { ApiEnvironment } from '@yoop/consumer-app/app-config';

// This file can be replaced during build by using the `fileReplacements` array.
export const apiConfig = {
  api: 'https://api.dev.yoop.app/',
};
